import { API_BASE_URL } from 'app/constants';

export const FEED_URL = `${API_BASE_URL}/feed/`;
export const POLLING_DELAY = 10000; // in millisec
